import React from 'react';
import './Experience.css';


const Button = ({ label, link }) => {

    return (
        <a className="tech">
            {label}
        </a>
    );
};

const containerStyle = {
    textAlign: 'left', // Align buttons to the left
    paddingBottom: '30px',
};

const Experience = () => {
    return (
        <div className="experience">
            <div className='exp-center'>
                <div className='fb'>
                    <h2 className='title'>Experience<span className="dot">.</span></h2>
                    <div className='line'></div>
                </div>
                <div className='exp'>
                    <div className='exp-n'>
                        <h2 className='head'>SoftwareAG</h2>
                        <h2 className='duration'>June 2023 - Present</h2>
                    </div>
                    <div className='exp-d'>
                        <h3 className='head2'>AI Intern</h3>
                        <h3 className='location'>Mumbai, IN</h3>
                    </div>
                    <div className='description'>
                        <p className='d'>I've developed an intelligent AI Bot employing NLP, Machine Learning, and React JS, providing a seamless experience by assisting users in finding product documentation and delivering personalized learning through contextually relevant information.</p>
                    </div>
                    <div className='skills' style={containerStyle}>
                        <div className="nav-bar">
                            <Button label="Python" className="nav-button" />
                            <Button label="React.js" className="nav-button" />
                            <Button label="Node.js" className="nav-button" />
                            <Button label="GoLang" className="nav-button" />
                            <Button label="LLM" className="nav-button" />
                            <Button label="MongoDB" className="nav-button" />
                            <Button label="GitHub" className="nav-button" />
                            <Button label="AWS" className="nav-button" />
                        </div>
                    </div>
                </div>
                <div className='sep'></div>
                <div className='exp'>
                    <div className='exp-n'>
                        <h2 className='head'>Ignitus</h2>
                        <h3 className='duration'>May 2023 - June 2023</h3>
                    </div>
                    <div className='exp-d'>
                        <h3 className='head2'>ML Intern <span className="remote">(Remote)</span></h3>
                        <h3 className='location'>Pennsylvania, PH</h3>
                    </div>
                    <div className='description'>
                        <p className='d'>I conducted Exploratory Data Analysis (EDA) on various datasets, created Educational Notebooks, utilized Logistic Regression to gain insights from the Wisconsin Breast Cancer Dataset, and applied clustering algorithms to efficiently segment customers in an Ecommerce dataset.</p>
                    </div>
                    <div className='skills' style={containerStyle}>
                        <div className="nav-bar">
                            <Button label="Python" className="nav-button" link="" />
                            <Button label="Google Colab" className="nav-button" link="" />
                            <Button label="Sklearn" className="nav-button" link="" />
                            <Button label="GitHub" className="nav-button" link="" />
                            <Button label="Git" className="nav-button" link="" />
                            <Button label="Seaborn" className="nav-button" link="" />
                        </div>
                    </div>
                </div>
                <div className='sep'></div>

                <div className='sep'></div>
                <div className='exp'>
                    <div className='exp-n'>
                        <h2 className='head'>Peka Consultancy Pvt. Ltd.</h2>
                        <h3 className='duration'>Jan 2022 - Mar 2022</h3>
                    </div>
                    <div className='exp-d'>
                        <h3 className='head2'>Web Developer Intern</h3>
                        <h3 className='location'>Mumbai, IN</h3>
                    </div>
                    <div className='description'>
                        <p className='d'>I enhanced website functionality, tailored existing sites to meet client preferences, implemented visually appealing designs using CSS principles, and maintained accurate databases through regular updates and data entry tasks.</p>
                    </div>
                    <div className='skills' style={containerStyle}>
                        <div className="nav-bar">
                            <Button label="HTML" className="nav-button" link="" />
                            <Button label="Javascript" className="nav-button" link="" />
                            <Button label="CSS" className="nav-button" link="" />
                            <Button label="PHP" className="nav-button" link="" />
                            <Button label="GitHub" className="nav-button" link="" />
                            <Button label="Laravel" className="nav-button" link="" />
                        </div>
                    </div>
                </div>
                <div className='sep'></div>
            </div>
        </div >

    );
};

export default Experience;